<div class="box">
  <!-- <span>{{x}}</span>
  <span>{{y}}</span> -->
</div>